import { error } from 'loglevel';
import { ModulesApiAdapter } from '../../../../data-providers/api/modules-api-adapter';
import { IApplication, IOption } from '../../../../domain/portal-domain';

const api = ModulesApiAdapter.getInstance();

export const loadModules = async (companyId: number, installationId?: number): Promise<IOption[]> => {
    let availableModules: IOption[] = [];

    try {
        availableModules = [...availableModules];
        if (installationId) {
            const installationModules = await loadInstallationModules(companyId, installationId);
            availableModules = [...availableModules, ...installationModules];
        }
    } catch (e) {
        error('Cannot load company modules', e);
    }

    return availableModules;
};

export const loadInstallationModules = async (companyId: number, installationId: number): Promise<IOption[]> => {
    let availableModules: IOption[] = [];
    try {
        const installationModules: IOption[] = await api.getAvailableInstallationModules(companyId, installationId);
        if (installationModules) {
            availableModules = [...availableModules, ...installationModules];
        }
    } catch (e) {
        error('Cannot load installation modules', e);
    }

    return availableModules;
};

export const loadAllApllicationsForInstallation = async (companyId: number, installationId: number): Promise<IApplication[]> => {
    let availableApplications: IApplication[] = [];
    try {
        const installationApps: IApplication[] = await api.getAllApplicationsForInstallation(companyId, installationId);
        if (installationApps) {
            availableApplications = [...installationApps];
        }
    } catch (e) {
        error('Cannot load installation applications', e);
    }

    return availableApplications;
};

export const uploadSignatureForUser = async (userId: number, file: File): Promise<any> => {
    try {
        const formData = new FormData();
        formData.append('formFile', file);
        await api.updateSignatureForUser(userId, formData);
    } catch (e) {
        console.error('Failed to upload signature', e);
        error('Failed to upload signature', e);
    }
};

export const removeSignatureForUser = async (userId: number): Promise<any> => {
    try {
        await api.removeSignatureForUser(userId);
    } catch (e) {
        console.error('Failed to delete signature', e);
        error('Failed to delete signature', e);
    }
};
